import * as React from 'react';
import { translate } from 'react-i18next';
import { browserHistory, RouteComponentProps } from 'react-router';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import * as c from 'models/constants';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { ItemCardList, ProductFilters, SortRow, AddEntityItemCard, NoResults, LoadingOverlayWrapper } from 'components';
import { ErrorPage } from 'containers';
import { ResultsWrapper } from 'components/PortalStructure';
import { getCategoryDomainValues } from 'modules/domainvalues';
import {
	getProductSearchResults,
	setProductSelectedCategory,
	resetSearchData,
	setProductSearchKeyword,
	setProductSortOrder,
	setRefinementGroups,
} from 'redux/modules/search/productsearchresults';
import { deleteProduct } from 'redux/modules/product/products';
import { INodeDto, IDropdownData, IAuthContext, ITranslateProps } from 'models/common';
import { ProductBaseSearch } from 'redux/modules/search/productBaseSearch';
import { Likes } from 'redux/modules/user/likes';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { Wishlists } from 'redux/modules/user/wishlists';
import { WishlistNodeType } from 'models/enums/nodetype/wishlistnodetype';
import { SearchUsage } from 'models/enums/searchusage';
import { ProductsSort } from 'models/enums/sortvalues';
import { IRefinementGroup, IRefinement } from 'models/filtering/refinement';
import { showModal, closeModal } from 'redux/modules/modal';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { ProductRefinementGroupings } from 'models';
import { getNextPageCount } from 'helpers/common';
import { Dispatch } from 'react-redux';

interface IOwnProps extends Pick<RouteComponentProps<{}, {}>, 'location'> {
	goToCard: (id: string, type: string, target: string) => void;
	usage: SearchUsage;
	selectItem?: (item: INodeDto) => void;
	disableCardActions?: boolean;
}

interface IProps
	extends IOwnProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps>,
		ITranslateProps {
	context?: IAuthContext;
}

interface IProductSearchResultsItemCardList extends IItemCardList {
	wishlistItem?: (itemType: string, itemId: string) => void;
	unwishItem?: (itemType: string, itemId: string) => void;
}

const mapStateToProps = (state: IStore) => ({
	productsSearchResultsData: state.productSearchResults,
	shopCard: state.shopcard,
	userPreferences: state.userPreferences,
	categoryDomainValues: state.domainValues.categories,
});

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	getProductSearchResults: (isFirstLoad: boolean, isRefinement: boolean, usage: SearchUsage) =>
		dispatch(getProductSearchResults(isFirstLoad, isRefinement, usage)),
	resetSearchData: () => dispatch(resetSearchData()),
	getCategoryDomainValues: () => dispatch(getCategoryDomainValues()),
	setProductSearchKeyword: (keyword: string) => dispatch(setProductSearchKeyword(keyword)),
	setProductSelectedCategory: (categoryId: number) => dispatch(setProductSelectedCategory(categoryId)),
	setProductSortOrder: (sortOrder: number) => dispatch(setProductSortOrder(sortOrder)),
	setRefinementGroups: (refinementGroups: IRefinementGroup[]) => dispatch(setRefinementGroups(refinementGroups)),
	deleteProduct: (id: string, shopId: string) => dispatch(deleteProduct(id, shopId)),
	showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
	closeModal: () => dispatch(closeModal()),
	dispatch,
});

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ProductSearchResultsComponent extends React.Component<IProps, any> {
	private wishlists: Wishlists = null;
	private likes: Likes = null;
	private itemsIds: string = '';

	constructor(props) {
		super(props);

		this.wishlists = new Wishlists(WishlistNodeType.ProductSearch);
		this.likes = new Likes(LikeNodeType.ProductSearch);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.getProductSearchResults = this.getProductSearchResults.bind(this);
		this.handleOnRefinementClick = this.handleOnRefinementClick.bind(this);
		this.handleSetSelectedCategory = this.handleSetSelectedCategory.bind(this);
		this.handleOnSortClick = this.handleOnSortClick.bind(this);
		this.likeItem = this.likeItem.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
		this.wishlist = this.wishlist.bind(this);
		this.unwish = this.unwish.bind(this);
		this.handleCreateProductClick = this.handleCreateProductClick.bind(this);
		this.openDeleteProduct = this.openDeleteProduct.bind(this);
		this.deleteProduct = this.deleteProduct.bind(this);
		this.setSelectedPriceValues = this.setSelectedPriceValues.bind(this);

		this.itemsIds = this.getItemsIds();
	}

	private getItemsIds() {
		return (this.props.productsSearchResultsData.items || []).map((item) => item.id).join(',');
	}

	public componentDidMount() {
		this.getLikes();
		this.props.getCategoryDomainValues();
		window.dispatchEvent(new Event('resize'));
	}

	public componentDidUpdate(prevProps: IProps) {
		const itemsIds = this.getItemsIds();
		if (prevProps.userPreferences.id !== this.props.userPreferences.id || this.itemsIds !== itemsIds) {
			this.getLikes();
		}
		window.dispatchEvent(new Event('resize'));

		this.itemsIds = itemsIds;
	}

	public componentWillUnmount() {
		this.props.resetSearchData();
	}

	private getLikes() {
		if (this.props.productsSearchResultsData.items && this.props.productsSearchResultsData.items.length > 0) {
			this.props.dispatch(this.likes.getLikedItems());
			this.props.dispatch(this.wishlists.getWishlistedItems());
		}
	}

	private loadMoreData() {
		this.getProductSearchResults(false, true);
	}

	private getProductSearchResults(isFirstLoad: boolean, isRefinement: boolean) {
		this.props.getProductSearchResults(isFirstLoad, isRefinement, this.props.usage);
	}

	private handleOnRefinementClick(groupId: number, refinementId: number) {
		if (groupId === ProductRefinementGroupings.Price) {
			this.props.getProductSearchResults(true, true, this.props.usage);
			if (this.props.location) {
				const currentUrlParams = new URLSearchParams(this.props.location.search);
				let r5: string = '';
				this.props.productsSearchResultsData.refinementGroups.forEach((reducerRefinementGroup: IRefinementGroup) => {
					if (reducerRefinementGroup.refinements.length) {
						if (
							reducerRefinementGroup.groupId === this.props.productsSearchResultsData.lastSelectedRefinementGroupId ||
							reducerRefinementGroup.groupId === ProductRefinementGroupings.Price
						) {
							r5 += 'g' + reducerRefinementGroup.groupId;
							reducerRefinementGroup.refinements.forEach((reducerRefinementGroupRefinements: IRefinement) => {
								r5 += 'r' + reducerRefinementGroupRefinements.id;
							});
						}
					}
				});
				currentUrlParams.set('r5', r5);
				browserHistory.push(this.props.location.pathname + '?' + currentUrlParams.toString());
			}
		} else {
			const productBase = new ProductBaseSearch(this.props.dispatch, c.NODE_TYPE_PRODUCT, this.props.usage);
			let lastActionWasToNarrowRefinement: boolean = false;
			if (!this.isDisabled(groupId, refinementId)) {
				if (this.isAvailable(groupId, refinementId)) {
					lastActionWasToNarrowRefinement = true;
				} else if (this.isSelectedButDisabled(groupId, refinementId)) {
					lastActionWasToNarrowRefinement = false; //? what to do in original file nothing
				} else {
					lastActionWasToNarrowRefinement = false;
				}
				this.props.dispatch(productBase.refineProductSearch(groupId, refinementId));
				if (this.props.location) {
					const currentUrlParams = new URLSearchParams(this.props.location.search);
					currentUrlParams.set('r1', refinementId.toString());
					currentUrlParams.set('r2', groupId.toString());
					currentUrlParams.set('r3', lastActionWasToNarrowRefinement.toString());
					let r4: string = '';
					this.props.productsSearchResultsData.refinementSelections.forEach(
						(reducerRefinementGroup: IRefinementGroup) => {
							if (reducerRefinementGroup.refinements.length) {
								r4 += 'g' + reducerRefinementGroup.groupId;
								reducerRefinementGroup.refinements.forEach((reducerRefinementGroupRefinements: IRefinement) => {
									r4 += 'r' + reducerRefinementGroupRefinements.id;
								});
							}
						},
					);
					currentUrlParams.set('r4', r4);
					let r5: string = '';
					this.props.productsSearchResultsData.refinementGroups.forEach((reducerRefinementGroup: IRefinementGroup) => {
						if (reducerRefinementGroup.refinements.length) {
							if (
								reducerRefinementGroup.groupId === groupId ||
								reducerRefinementGroup.groupId === ProductRefinementGroupings.Price
							) {
								r5 += 'g' + reducerRefinementGroup.groupId;
								reducerRefinementGroup.refinements.forEach((reducerRefinementGroupRefinements: IRefinement) => {
									r5 += 'r' + reducerRefinementGroupRefinements.id;
								});
							}
						}
					});
					currentUrlParams.set('r5', r5);
					browserHistory.push(this.props.location.pathname + '?' + currentUrlParams.toString());
				}
			}
		}
	}

	private handleSetSelectedCategory(categoryId: number) {
		const lastSearchedKeyword = this.props.productsSearchResultsData.keyword;
		this.props.resetSearchData();
		this.props.setProductSearchKeyword(lastSearchedKeyword);
		this.props.setProductSelectedCategory(categoryId);
		this.props.getProductSearchResults(true, false, this.props.usage);
		if (this.props.location) {
			browserHistory.push(this.props.location.pathname + '?cat=' + categoryId);
		}
	}

	private handleOnSortClick(sortOrder: number) {
		this.props.setProductSortOrder(sortOrder);
		this.props.getProductSearchResults(true, true, this.props.usage);
		if (this.props.location) {
			const currentUrlParams = new URLSearchParams(this.props.location.search);
			currentUrlParams.set('o', sortOrder.toString());
			browserHistory.push(this.props.location.pathname + '?' + currentUrlParams.toString());
		}
	}

	private likeItem(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.ProductSearch);
			this.props.dispatch(likes.likeItem(itemId));
		} else {
			signinRedirect();
		}
	}

	private unlikeItem(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const likes = new Likes(LikeNodeType.ProductSearch);
			this.props.dispatch(likes.unlikeItem(itemId));
		} else {
			signinRedirect();
		}
	}

	private wishlist(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const wishlists = new Wishlists(WishlistNodeType.ProductSearch);
			this.props.dispatch(wishlists.wishlist(itemId));
		} else {
			signinRedirect();
		}
	}

	private unwish(_, itemId: string) {
		const { isAuthenticated, signinRedirect } = this.props.context;
		if (isAuthenticated()) {
			const wishlists = new Wishlists(WishlistNodeType.ProductSearch);
			this.props.dispatch(wishlists.unwish(itemId));
		} else {
			signinRedirect();
		}
	}

	private openDeleteProduct(_, itemId: string) {
		const dialogContent = (
			<div>
				<img src={require('containers/Html/icons/icon_notification.png')} />
				<h2>{this.props.t('BSPortal_Common_ConfirmationDialog_Sure')}</h2>
				<p>{this.props.t('Magazine_Article_Articles_DeleteUserMessage')}</p>
				<p>{this.props.t('BSPortal_Common_ConfirmationDialog_Confirm')}</p>
			</div>
		);

		this.props.showModal('ConfirmationDialog', {
			confirmAction: this.deleteProduct,
			value: itemId,
			yesButtonText: this.props.t('BSPortal_Common_YesDelete'),
			noButtonText: this.props.t('BSPortal_Common_NoWait'),
			content: dialogContent,
			closeModal: this.props.closeModal,
		});
	}

	private deleteProduct(confirm: boolean, itemId: string) {
		if (confirm) {
			this.props.deleteProduct(itemId, this.props.shopCard.shopcard.id);
		}
		this.props.closeModal();
	}

	private handleCreateProductClick() {
		browserHistory.push('/shop/' + this.props.shopCard.shopcard.id + '/edit/products/create');
	}

	// copied from productFiltering.ts
	private isDisabled(refinementGroupId: number, refinementItemId: number) {
		const refinementItem = this.getRefinementFromArray(
			this.props.productsSearchResultsData.refinementGroups,
			refinementGroupId,
			refinementItemId,
		);
		if (refinementItem && refinementItem.disabled) {
			return true;
		}
		return false;
	}

	private getRefinementFromArray(
		refinementGroups: IRefinementGroup[],
		refinementGroupId: number,
		refinementItemId: number,
	): IRefinement {
		return refinementGroups
			.filter((x) => x.groupId === refinementGroupId)[0]
			.refinements.filter((y) => y.id === refinementItemId)[0];
	}

	private isAvailable(refinementGroupId: number, refinementItemId: number) {
		const refinementItem = this.getRefinementFromArray(
			this.props.productsSearchResultsData.refinementGroups,
			refinementGroupId,
			refinementItemId,
		);
		if (refinementItem && refinementItem.available) {
			return true;
		}
		return false;
	}

	private isSelectedButDisabled(refinementGroupId: number, refinementItemId: number) {
		return this.isSelected(refinementGroupId, refinementItemId) && this.isDisabled(refinementGroupId, refinementItemId);
	}

	private isSelected(refinementGroupId: number, refinementItemId: number) {
		const refinementItem = this.getRefinementFromArray(
			this.props.productsSearchResultsData.refinementGroups,
			refinementGroupId,
			refinementItemId,
		);
		if (refinementItem && refinementItem.selected) {
			return true;
		}
		return false;
	}

	private setSelectedPriceValues(values: number[]) {
		const refinementGroups = this.props.productsSearchResultsData.refinementGroups;
		const pricesRefinementGroupIndex = refinementGroups.findIndex(
			(x) => x.groupId === ProductRefinementGroupings.Price,
		);
		if (pricesRefinementGroupIndex > -1) {
			refinementGroups[pricesRefinementGroupIndex].refinements[0].id = values[0];
			refinementGroups[pricesRefinementGroupIndex].refinements[1].id = values[1];
			this.props.setRefinementGroups(refinementGroups);
		}
	}

	public render() {
		if (this.props.productsSearchResultsData.error) {
			return <ErrorPage {...this.props} message={this.props.productsSearchResultsData.message} />;
		}

		const { items, itemsPage, refinementGroups, sortOrder, isFetching, keyword, refinementSelections } =
			this.props.productsSearchResultsData;

		const selectedCategoryId = this.props.productsSearchResultsData.selectedCategoryId;

		const { t, categoryDomainValues } = this.props;

		if (!itemsPage) {
			return '';
		}

		const nextPageItems = getNextPageCount(itemsPage, items.length);

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: nextPageItems > 0,
			loader: <>{t('BSPortal_Common_Loading')} </>,
			// loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const keys = items.map((i) => i.entityId);

		const listProps: IProductSearchResultsItemCardList = {
			items: items.filter((p, i) => !p.entityId || keys.indexOf(p.entityId) === i),
			itemType: c.NODE_TYPE_PRODUCT_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			currentUserId: this.props.userPreferences.id,
			likeItem: this.likeItem,
			unlikeItem: this.unlikeItem,
			selectItemObject: this.props.selectItem,
			wishlistItem: this.wishlist,
			unwishItem: this.unwish,
			isFetching,
			loadingText: t('BSPortal_Common_Loading'),
			noResults: <NoResults keyword={keyword} t={t} />,
			////////////////////////////////////////////////////////////
			// goToCard: this.props.goToCard, // TODO reenable goToCard when card styling is complete
			////////////////////////////////////////////////////////////
			goToCard: () => null,
			////////////////////////////////////////////////////////////
			disableActions: this.props.disableCardActions,
			nextPageItems,
		};

		const sortItems: IDropdownData[] = [];

		if (this.props.usage === SearchUsage.ProductsShopCard) {
			listProps.currentUserIsAdministrator = this.props.userPreferences.isAdministrator;
			listProps.currentUserIsEditor = this.props.userPreferences.isEditor;

			listProps.isMyItem = false;
			if (this.props.shopCard.isMyShop) {
				listProps.addItemCard = (
					<AddEntityItemCard
						action={this.handleCreateProductClick}
						text={t('Shop_ManageShop_Products_Button_AddProduct')}
					/>
				);
				listProps.isMyItem = true;
				listProps.editItem = (productId: string) => {
					browserHistory.push(`/shop/${this.props.shopCard.shopcard.id}/edit/products/${productId}/edit`);
				};
				listProps.deleteItem = this.openDeleteProduct;
			}
		}

		for (const n in ProductsSort) {
			if (typeof ProductsSort[n] === 'number') {
				sortItems.push({ key: ProductsSort[n], value: t('ProductsSearchResults_Sort_' + n) });
			}
		}

		const pricesRefinementGroup: IRefinementGroup = this.props.productsSearchResultsData.refinementGroups.find(
			(x) => x.groupId === ProductRefinementGroupings.Price,
		);

		const filterProps = {
			refinementGroups,
			categories: categoryDomainValues,
			selectedCategoryId,
			onRefinementClick: this.handleOnRefinementClick,
			setSelectedCategory: this.handleSetSelectedCategory,
			pricesRefinementGroup,
			priceStep: 1,
			onPriceValuesChange: this.setSelectedPriceValues,
			onFinalPriceValuesChange: (values: number[]) => {
				this.handleOnRefinementClick(ProductRefinementGroupings.Price, values[0]);
			},
		};

		const filter = <ProductFilters {...filterProps} />;

		const sortRowProps = {
			entityData: null,
			items: sortItems,
			selectedItem: sortOrder,
			onSortClick: this.handleOnSortClick,
		};

		const sortRow = <SortRow {...sortRowProps} />;

		return (
			<LoadingOverlayWrapper active={this.props.productsSearchResultsData.isFetching}>
				<ResultsWrapper
					itemsCount={items.length}
					complexFilter={filter}
					sortComponent={sortRow}
					refinementSelections={refinementSelections}
					onRemoveSelectedFilter={(groupId: number, refinementId: number) => {
						this.handleOnRefinementClick(groupId, refinementId);
					}}
					onResetFiltersClick={() => {
						this.handleSetSelectedCategory(selectedCategoryId);
					}}
					pricesRefinementGroup={pricesRefinementGroup}
					onPriceFilterRemove={(availablePriceMax: number) => {
						this.setSelectedPriceValues([0, availablePriceMax]);
						this.handleOnRefinementClick(ProductRefinementGroupings.Price, availablePriceMax);
					}}
				>
					<ItemCardList {...listProps} />
				</ResultsWrapper>
			</LoadingOverlayWrapper>
		);
	}
}
const ProductSearchResults = connect(
	mapStateToProps,
	mapDispatchToProps,
)(withAuthContext(ProductSearchResultsComponent));
export { ProductSearchResults };
